import PhotoPlaceholder from './PhotoPlaceholder';

export default PhotoPlaceholder;
